import { render } from "./resource-menu.vue?vue&type=template&id=122a0961&ts=true"
import script from "./resource-menu.ts?vue&type=script&lang=ts&external"
export * from "./resource-menu.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__